
<template>
  <div>
        <!-- v-model="photo_now"  -->
    <v-carousel 
      v-if="photos"
      :hide-delimiters="photos.length==1"
      :show-arrows="photos.length>1"
      touchless
      v-model='photo_now'
      height="auto"
      style="border-radius: 0px"
    >
      <v-carousel-item  
        v-for="(one_photo, idx) in [...photos]"
        :key="`${wichPhoto(one_photo)}-${idx}`"
      > 
        <div v-if="allow_delete" class="text-right">
          <v-btn icon color="error" @click="emitDelete(idx, one_photo)"> <v-icon>mdi-delete</v-icon> </v-btn>
        </div>
        <!-- {{one_photo}} -->
        <v-img contain :src="wichPhoto(one_photo)" lazy-src="https://www.bliss.cool/images/giphy.gif" :height="height || '400px'"></v-img>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: '',
  props: {
    height:{
      type: String,
      default: "400px"
    },
    photos: {
      type: Array,
      default: ()=>[]
    },
    allow_delete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      photo_now: 0,
      // key: null
    }
  },
  methods: {
    wichPhoto(photo){
      if (typeof(photo)=='string'){
        return photo
      } else {
        return photo.url
      }
    },
    emitDelete(idx, photo) {
      let obj = {idx}
      if (photo.id){
        obj= {
          ...obj, 
          id: photo.id
        }
      }
      // console.log({obj});
      this.$emit('photoToDelete', obj)
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    photos:{
      handler (nv) {
        // console.log({nv});
        setTimeout(() => {
          this.photo_now = nv.length? nv.length-1 : 0 
        }, 800);
      },
    }
  },
}
</script>

<style scoped>

</style>